import type { Component } from 'solid-js'
import { For, Show } from 'solid-js'
import Button from '~/components/Button'
import Card from '~/components/Card'
import Chip from '~/components/Chip'
import Icon from '~/components/Icon'
import { P } from '~/utils/permissions'
import type { TabDocumentosProps } from './types'
import { documentColor, documentIcon, formatBytes, MAX_DOCUMENT_BYTES } from './utils'

const TabDocumentos: Component<TabDocumentosProps> = props => {
  return (
    <>
      <div class="flex justify-end mb-4">
        <Show when={props.can(P.customers.update)}>
          <Button size="sm" variant="soft" color="primary" onClick={() => props.openDocumentModal()} prependIcon="material-symbols-light:upload">
            Subir documento
          </Button>
        </Show>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <For
          each={props.data.documents ?? []}
          fallback={
            <div class="col-span-full rounded-xl border border-dashed border-border py-10 text-center">
              <Icon icon="material-symbols-light:folder-open-outline" size={40} class="text-foreground-subtle/50" />
              <p class="text-foreground-subtle mt-2">Sin documentos adjuntos.</p>
              <p class="text-xs text-foreground-subtle/70">Cédula, RUT, contratos… hasta {MAX_DOCUMENT_BYTES / 1024 / 1024} MB por archivo.</p>
            </div>
          }
        >
          {doc => (
            <Card class="h-full">
              <Card.Body class="flex flex-col h-full">
                <div class="flex items-start gap-3">
                  <span class={`size-10 shrink-0 rounded-lg flex items-center justify-center ${documentColor(doc.mimeType)}`}>
                    <Icon icon={documentIcon(doc.mimeType)} size={22} />
                  </span>
                  <div class="min-w-0 flex-1">
                    <p class="font-semibold text-foreground truncate" title={doc.name}>
                      {doc.name}
                    </p>
                    <p class="text-xs text-foreground-subtle">
                      {formatBytes(doc.size)} · {new Date(doc.createdAt).toLocaleDateString('es-CO')}
                    </p>
                  </div>
                  <Show when={doc.category}>
                    <Chip color="info" variant="soft" size="xs" class="shrink-0">
                      {doc.category?.label}
                    </Chip>
                  </Show>
                </div>
                <Show when={doc.description}>
                  <p class="mt-3 text-sm text-foreground-subtle line-clamp-2">{doc.description}</p>
                </Show>
                <div class="mt-auto pt-3 flex justify-end gap-1">
                  <Button
                    size="xs"
                    variant="text"
                    color="default"
                    onClick={() => props.openDocument(doc)}
                    icon="material-symbols-light:visibility-outline"
                    aria-label="Ver documento"
                    tooltip="Ver / descargar"
                  />
                  <Show when={props.can(P.customers.update)}>
                    <Button
                      size="xs"
                      variant="text"
                      color="default"
                      onClick={() => props.openDocumentModal(doc)}
                      icon="material-symbols-light:edit-outline"
                      aria-label="Editar documento"
                      tooltip="Editar categoría y notas"
                    />
                  </Show>
                  <Show when={props.can(P.customers.delete)}>
                    <Button size="xs" variant="text" color="danger" onClick={() => props.removeDocument(doc)} icon="material-symbols-light:delete-outline" aria-label="Eliminar documento" />
                  </Show>
                </div>
              </Card.Body>
            </Card>
          )}
        </For>
      </div>
    </>
  )
}

export default TabDocumentos
